let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iDY17")).then(() => parcelRequire('cKEZ7'));